/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Suggestion } from './Suggestion.js';
import {
    SuggestionFromJSON,
    SuggestionFromJSONTyped,
    SuggestionToJSON,
} from './Suggestion.js';

/**
 * 
 * @export
 * @interface CreateSuggestionResponse
 */
export interface CreateSuggestionResponse {
    /**
     * 
     * @type {Suggestion}
     * @memberof CreateSuggestionResponse
     */
    data?: Suggestion;
    /**
     * 
     * @type {number}
     * @memberof CreateSuggestionResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSuggestionResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSuggestionResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CreateSuggestionResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CreateSuggestionResponse interface.
 */
export function instanceOfCreateSuggestionResponse(value: object): boolean {
    return true;
}

export function CreateSuggestionResponseFromJSON(json: any): CreateSuggestionResponse {
    return CreateSuggestionResponseFromJSONTyped(json, false);
}

export function CreateSuggestionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSuggestionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SuggestionFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateSuggestionResponseToJSON(value?: CreateSuggestionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': SuggestionToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

